import { defineComponent as _defineComponent } from 'vue'
import { getSimpleCategory } from '@/api/ware/category';
import queryWare from '@/api/ware/management';
import { useForm } from '@/util/useForm';
import { createPointsProduct } from '@/view/marketing/api/points';
import { message } from 'ant-design-vue';
import { ref, watch, computed } from 'vue';
import { formatDate } from '../../../../../util/global';

export default /*#__PURE__*/_defineComponent({
  __name: 'SelectProduct',
  emits: ["onAdd"],
  setup(__props, { emit }) {

const STATUS_LIST: any = [
  {
    value: 0,
    label: '全部',
  },
  {
    value: 1,
    label: '已上架',
  },
  {
    value: 2,
    label: '已下架',
  },
];

const ware_category_list = ref<any[]>([]);
(async () => {
  const res = await getSimpleCategory();
  res.unshift({
    id: 0,
    name: '全部',
  });
  ware_category_list.value = res;
})();

const modalVisible = ref<boolean>(false);
function openModal() {
  modalVisible.value = true;
}
function okNext() {
    nextVisible.value = true
  modalVisible.value = false;
}
async function query(params) {
  const res = await queryWare(params.current, {...params,filter_promotion_product:1});
  dataSource.value = res.detail;
  pagination.value = {
    current: Number(res.current),
    total: Number(res.total),
    pageSize: Number(res.limit),
    showTotal: () => `共${res.total}条, 每页${res.limit}条`,
  };
}
const queryParams = ref<any>({});
watch(
  queryParams,
  () =>{
    const ware_category_id = queryParams.value?.ware_category_id as number[]|undefined
    let category_id: number|undefined = undefined
    if(ware_category_id){
        category_id = ware_category_id[ware_category_id.length-1]
    }
    query({
      ...queryParams.value,
      category_id
    })
  }
    ,
  { immediate: true }
);

const form = useForm();
//表单提交
function submit(e) {
  //移除表单提交默认事件
  e.preventDefault();
  const formdata = form.value.getFormValue();
  queryParams.value = {
    ...queryParams.value,
    current: 1,
    ...formdata,
  };
}
//重置表单
function clearForm() {
  form.value.resetFields();
  queryParams.value = { current: 1 };
}
const dataSource = ref<any[]>([]);
const pagination = ref<{
  current: number;
  total: number;
  pageSize: number;
  showTotal: () => string;
}>({
  current: 1,
  total: 0,
  pageSize: 20,
  showTotal: () => `共0条, 每页20条`,
});
function onPagination(page: { current: number; pageSize: number; showTotal: any; total: number }) {
  queryParams.value = {
    ...queryParams.value,
    current: page.current,
  };
}
const selectedRowKeys = ref<any[]>([]);
function onSelect(val) {
  selectedRowKeys.value = val;
}
const addProduct= ref<any[]>([])

const nextVisible = ref<boolean>(false);
async function onAdd(){
  let hasFilled = false
  const params = addProduct.value.map(item=>{
    if(!item.points){
      hasFilled=true
    }
    return {
    product_id:item.id,
    title:item.title,
    points:item.points
  }})
  if(hasFilled){
    message.warning('请填写所需积分且积分不能为0')
    return
  }
  await createPointsProduct(params)
  emit('onAdd')
  nextVisible.value=false
}
watch(modalVisible,()=>{
  if(modalVisible.value==true){
    selectedRowKeys.value=[]
  }
})
watch(selectedRowKeys,()=>{
  const res = [
    ...addProduct.value.filter(item=>selectedRowKeys.value.includes(item.id)),
    ...dataSource.value.filter(item=>selectedRowKeys.value.includes(item.id)&&!addProduct.value.find(i=>i.id===item.id))
]
console.log(res);

  addProduct.value = res
})



return { __sfc: true,STATUS_LIST, emit, ware_category_list, modalVisible, openModal, okNext, query, queryParams, form, submit, clearForm, dataSource, pagination, onPagination, selectedRowKeys, onSelect, addProduct, nextVisible, onAdd, formatDate }
}

})